export default ({ request }) => ({
  mrpPurchaseOrderListApi(data = {}) {
    return request({
      url: '/factory/mrp/purchase/order/list',
      method: 'post',
      data,
    })
  },
  mrpPurchaseOrderDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/purchase/order/detail',
      method: 'post',
      data,
    })
  },
  mrpPurchaseOrderSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/purchase/order/save',
      method: 'post',
      data,
    })
  },
  mrpPurchaseOrderDelApi(data = {}) {
    return request({
      url: '/factory/mrp/purchase/order/del',
      method: 'post',
      data,
    })
  },
  mrpPurchaseOrderSubmitApi(data = {}) {
    return request({
      url: '/factory/mrp/purchase/order/submit',
      method: 'post',
      data,
    })
  },
})
